<template>
	<section class="hp_blog hp_blog_inpost hp_blog--new">
		<div class="container">
			<h3 class="title center">{{ blogs.title }}</h3>
			<div class="slide_blog_wrap">
				<div class="arrow_r ease" v-if="blogs.posts.length > 4">
					<a href="javascript:void(0);" @click.prevent="prev">
						<arrow-right />
					</a>
				</div>
				<div class="arrow_l ease" v-if="blogs.posts.length > 4">
					<a href="javascript:void(0);" @click.prevent="next">
						<arrow-left />
					</a>
				</div>
				<div class="slide_blog clearfix">
					<Slick ref="blog" :options="slickOptions" v-if="assets_url">
						<div
							class="slide_blog_item"
							v-for="(item, index) in blogs.posts"
							:key="index"
						>
							<div class="slide_blog_item_in ease">
								<a-div
									:href="item.link.replace(home_url, '')"
									class="cover"
								>
									<div class="image-container">
										<img
											:src="item.image"
											:alt="item.title"
										/>
										<span class="frame absolute"></span>
									</div>
									<div
										class="texts center"
										:style="'background-color: #FFBF3F'"
									>
										<p class="post-title">
											<span>{{ item.title }}</span>
										</p>
										<p
											class="post-link"
											v-if="item.call_to_action"
										>
											{{ item.call_to_action }}
											<arrow-long />
										</p>
									</div>
								</a-div>
							</div>
						</div>
					</Slick>
				</div>
				<p>
				<div class="bt_green ease all-posts-container">
					<router-link :to="{name:'blog'}" class="all-posts">&nbsp;לכל המתכונים של כרמלה&nbsp;</router-link>
				</div>
			</p>
			</div>

			<div class="bt_border ease" v-if="false">
				<router-link to>לבלוג</router-link>
			</div>
		</div>
	</section>
</template>
<script>
	import arrowLeft from "../../assets/img/arrow_l.svg";
	import arrowRight from "../../assets/img/arrow_r.svg";
	import arrowLong from "../../assets/img/arrow-long.svg";
	import CHEF from "../../assets/img/chef.svg";
	import Slick from "vue-slick";

	export default {
		props: ["title", "posts"],
		data() {
			return {
				assets_url: wpData.assets_url,
				hp_blogs: JSON.parse(wpData.home_blogs),
				home_url: wpData.home_url,
				slickOptions: {
					rtl: true,
					dots: false,
					arrows: false,
					infinite: true,
					centerMode: false,
					slidesToShow: 4,
					slidesToScroll: 4,
					autoplay: false,
					autoplaySpeed: 2000,
					responsive: [
						{
							breakpoint: 1200,
							settings: {
								slidesToShow: 2,
							},
						},
						{
							breakpoint: 800,
							settings: {
								slidesToShow: 2,
                slidesToScroll: 2,
								arrows: false,
								dots: true,
								// infinite: false,
							},
						},
						{
							breakpoint: 650,
							settings: {
								slidesToShow: 1,
                slidesToScroll: 1,
								arrows: false,
								dots: true,
								// infinite: false,
							},
						},
					],
				},
			};
		},
		methods: {
			next() {
				this.$refs.blog.next();
			},
			prev() {
				this.$refs.blog.prev();
			},
		},
		computed: {
			blogs() {
				var blogs = {
					title: "עוד מתכונים שאולי תאהב",
					posts: {},
				};
				if (typeof this.posts != "undefined") {
					blogs.posts = this.posts;
					return blogs;
				}
				return this.hp_blogs;
			},
		},
		components: {
			arrowRight,
			arrowLeft,
			CHEF,
			arrowLong,
			Slick,
		},
	};
</script>

<style lang="scss" scoped>
  .hp_blog {
    padding-bottom: 1em;
    @media (max-width: 480px) {
      padding-top: 0;
    }

    .texts.center {
      background-color: rgb(255, 191, 63) !important;
    }
  }

  .title {
    color: #355731;
    margin-bottom: 0;
  }

  .post-title {
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  a.all-posts {
    margin: 0 !important;
  }

  @media (max-width: 480px) {
    .all-posts-container {
      margin: 1em 0 3em;
    }
  }

  .slide_blog_wrap {
    .all-posts-container a {
      background: none;
      border: 1px solid #1e824c;
      color: #1e824c;

      &:hover {
        background: #1e824c;
        color: #fff;
      }
    }
  }
  .slide_blog {
    padding: 0;
    margin: 0 -20px;

    ::v-deep {
      .slick-slide {
        & > div {
          @media (min-width: 768px) {
            padding: 30px 20px;
          }

          .slide_blog_item {
            margin: 0;
          }
        }
      }
      @media (max-width: 480px) {
        .slick-dots {
          position: static;
        }
      }
    }
  }
</style>

<style lang="sass" scoped>

	.image-container
		position: relative
		overflow: hidden
		img
			width: 100%
	.texts
		display: block
		font-family: simpler, raanancondensed
		padding: 1rem
		margin: 0 auto

	.post-title
		color: #000
		font-weight: 900
		font-size: 25px
		max-width: 320px
		margin: 0 auto 0.5rem
		line-height: 1.15
	.post-link
		max-width: 320px
		margin: 0 auto
		color: #333
		font-weight: bold
	.all-posts-container
		text-align: center
	.all-posts
		display: inline-block
		padding: 0 1.5rem
		margin: 20px auto 0 auto !important
		width: auto
		white-space: nowrap

	// Mobile
	@media screen and (max-width:800px)
		.slide_blog_item_in
			box-shadow: none
		.image-container
			border-radius: 0px 20px 0px 0px
		.texts
			background: transparent !important
		.post-title
			font-size: 20px
		.post-link
			font-size: 14px
		.link_long
			font-size: 14px
</style>
